import React from 'react';
import { connect } from 'react-redux';
import NoDataAndLoading from 'components/NoDataAndLoading';
import {
  onClickRow,
  closeRightColumn,
  onClickNewRole,
  rolesRequest,
  pageRequest,
  setRoles,
} from 'actions/employees/role';
import _groupBy from 'lodash/groupBy';
import { askConfirmAction } from 'actions/confirm-action';
import { isDirty } from 'redux-form';
import {
  ContentWrapper,
  LeftColumnWrapper,
  RightColumnWrapper,
  PageWrapper,
} from 'components/wrappers/pages';
import styles from './Role.css';
import RoleDetail from './RoleDetail';
import ActionBar from './ActionBar';
import List from './List';

class Role extends React.Component {
  componentWillMount() {
    this.props.pageRequest(this.props.user.id);
  }

  componentWillUnmount() {
    this.props.setRoles([]);
  }

  render() {
    const {
      role,
      closeRightColumn,
      loadingSpinner: { showLoadingSpinnerPage },
    } = this.props;
    return (
      <PageWrapper>
        <ContentWrapper>
          <ActionBar onClickNewRole={this._onClickNewRole} />
          <div className={styles.container}>
            <LeftColumnWrapper
              openRightColumn={role.openRightColumn}
              isWiderLeft
            >
              <NoDataAndLoading
                showLoadingSpinner={showLoadingSpinnerPage}
                noDataToDisplay={role.roles.length === 0}
                title="No role information"
                description={
                  'you can create a role and setup employee privileges by clicking "New Role" button on the top right corner'
                }
              />
              {!showLoadingSpinnerPage && role.roles.length !== 0 && (
                <List
                  role={role}
                  onClickRow={this._onClickRow}
                  onReachBottom={this._onReachBottom}
                  hasMore={this._hasMore()}
                  userPermissions={this.props.permissions}
                  openRightColumn={role.openRightColumn}
                />
              )}
            </LeftColumnWrapper>
            <RightColumnWrapper
              openRightColumn={role.openRightColumn}
              isWiderLeft
              menuName="role"
            >
              <RoleDetail closeRightColumn={closeRightColumn} />
            </RightColumnWrapper>
          </div>
        </ContentWrapper>
      </PageWrapper>
    );
  }

  _onClickNewRole = () => {
    const { askConfirmAction, isDirtyRole } = this.props;
    const data = {
      activePermissionApp: _groupBy(this.props.permissions, 'access').App,
    };

    if (isDirtyRole) {
      askConfirmAction(onClickNewRole(data));
    } else {
      this.props.onClickNewRole(data);
    }
  };

  _onClickRow = role => {
    const { askConfirmAction, isDirtyRole } = this.props;
    if (isDirtyRole) {
      askConfirmAction(onClickRow(role));
    } else {
      this.props.onClickRow(role);
    }
  };

  _onReachBottom = () => {
    const { currentPage, role, rolesRequest } = this.props;
    rolesRequest({ page: currentPage + 1 }, role.roles);
  };

  _hasMore = () => {
    const { currentPage, totalPage } = this.props;
    return currentPage < totalPage;
  };
}

function mapStateToProps(state) {
  const {
    loadingSpinner,
    moka: { permissions, user },
    employee: { role },
  } = state;
  return {
    role,
    loadingSpinner,
    user,
    permissions,
    isDirtyRole: isDirty('role')(state),
  };
}

export default connect(
  mapStateToProps,
  {
    onClickRow,
    onClickNewRole,
    closeRightColumn,
    rolesRequest,
    pageRequest,
    setRoles,
    askConfirmAction,
  }
)(Role);
